import ArrowLeftRegular from 'mini-fluent-svg-icons/lib/icons/ArrowLeftRegular';
import closeReadingPane from 'mini-mail-reading-pane-store/lib/utils/closeReadingPane';
import React from 'react';
import strings from 'owa-strings/owa-mini-strings';
import { Header, HeaderIcons, HeaderIconType } from 'mini-header';
import { logUsage } from 'owa-analytics';
import { setDidReadingPaneHeaderLoadingFail } from 'mini-mail-placeholder-components-store/lib/actions/setDidReadingPaneHeaderLoadingFail';
import { useChangeRoute } from 'route-state-utils/lib/hooks/useChangeRoute';

const styles = require('./MailReadingPaneHeader.scss');
const classNames = require('classnames/bind').bind(styles);

export const MailReadingPaneHeaderErrorBoundary = () => {
    const { goBack } = useChangeRoute();
    const onReadingPaneExit = () => {
        closeReadingPane();
        goBack();
    };
    const leftIcon: HeaderIconType = {
        icon: ArrowLeftRegular,
        ariaLabel: strings.backButtonAriaLabel,
        onClick: () => {
            onReadingPaneExit();
            logUsage('SHOW_BLANK_READING_PANE_BACK_BUTTON');
            setDidReadingPaneHeaderLoadingFail(false);
        },
    };
    return (
        <Header
            leftContent={<HeaderIcons icons={[leftIcon]} />}
            className={classNames(styles.mailReadingPaneHeader)}
        />
    );
};
